import * as Factory from 'factory.ts'
import faker from 'faker'

import { type PayRequestApproval } from '@webapp/models/PayRequest'
import { AccountMock } from './account.factory'
import { CurrencyMock } from './currency.factory'
import { DepartmentMock } from './department.factory'
import { SimplePayCardMock } from './payCard.factory'
import { PayCardholderMock } from './payCardholder.factory'
import { SimpleUserMock } from './user.factory'

const { id, firstName, lastName, email, profile_image } = SimpleUserMock.build()

export const PayApprovalMock = Factory.Sync.makeFactory<PayRequestApproval>({
  id: Factory.each(() => faker.random.number()),
  account: AccountMock.build(),
  amount: Factory.each(() => faker.random.number().toString()),
  currency: CurrencyMock.build({
    name: 'CAD',
  }),
  card: SimplePayCardMock.build(),
  cardholder: PayCardholderMock.build(),
  date_created: Factory.each(() => faker.date.past(10).toISOString()),
  department: DepartmentMock.build(),
  reason: Factory.each(() => faker.lorem.sentence()),
  next_approver: SimpleUserMock.build(),
  status: 1,
  uuid: Factory.each(() => faker.random.uuid()),
  logs: [],
  attachments: [],
  comment_object_id: Factory.each(() => faker.random.number()),
  title: Factory.each(() => faker.lorem.sentence()),
  fund: null,
  next_approver_choices: [],
  requester: {
    id,
    firstName,
    lastName,
    email,
    profile_image,
  },
})
